import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { AuthStore } from '../core/auth/auth-store';

export const cipherKeyResolver: ResolveFn<string> = (route) => {
  const authStore = inject(AuthStore);
  const cipherKey = typeof route.params['cipherKey'] === 'string' ? route.params['cipherKey'] : '';

  authStore.cipherKey.set(cipherKey);

  return cipherKey;
};
